import setValuationItemPercentages from '../Services/setValuationItemPercentages';

export default (percentage) => async (dispatch) => {
  
  dispatch(setValuationItemPercentages(percentage));

}